import Moment from 'moment';

/**
 * Given a date, convert it to a UTC timestamp
 *
 * NOTE!!!! -- This function works for internal calculations, but it does not work when you eventually
 * call moment.format().  I really don't know why.  Anyhow, we should use convertToUTCDateForFormat specifically for
 * calls to moment.format() or formatFromNow() and that sort of thing.  For calling toISOString(), you would
 * use this function.
 *
 * @param {Date} dateToConvert
 * @param {Boolean=} opt_asMoment
 * @return {Moment|Date}    This will be a new Date or Moment and won't mutate the dateToConvert
 */
export function convertToUTCDate(dateToConvert, opt_asMoment = true) {
  let convertedMoment = Moment(dateToConvert).add(Moment(dateToConvert).utcOffset(), 'm').utc();

  return opt_asMoment ?
    convertedMoment :
    convertedMoment.toDate();
}

/**
 * Given a date, convert it to a UTC timestamp.  Specifically for call to moment.format()
 *
 * @param {Date} dateToConvert
 * @param {Boolean=} opt_asMoment
 * @return {Moment|Date}    This will be a new Date or Moment and won't mutate the dateToConvert
 */
export function convertToUTCDateForFormat(dateToConvert, opt_asMoment = true) {
  let utcMoment = Moment([
    dateToConvert.getUTCFullYear(),
    dateToConvert.getUTCMonth(),
    dateToConvert.getUTCDate(),
    dateToConvert.getUTCHours(),
    dateToConvert.getUTCMinutes(),
    dateToConvert.getUTCSeconds(),
    dateToConvert.getUTCMilliseconds()]);

  return opt_asMoment ?
    utcMoment :
    utcMoment.toDate();
}

/**
 * Converts seconds to milliseconds
 *
 * @method getMsFromSeconds
 * @param seconds {Number}
 * @returns Number | Undefined
 * @private
 */

export function getMsFromSeconds(seconds) {

  // seconds must be a number
  try {
    if (typeof seconds !== 'number') {
      throw 'getMsFromSeconds: "seconds" param must be a number!';
    }
  } catch (e) {
    console.error(e);
    return;
  }

  return seconds * 1000;
}

/**
 * Converts minutes to milliseconds
 *
 * @method getMsFromMinutes
 * @param minutes {Number}
 * @returns Number | Undefined
 * @private
 */

export function getMsFromMinutes(minutes) {

  // minutes must be a number
  try {
    if (typeof minutes !== 'number') {
      throw 'getMsFromMinutes: "minutes" param must be a number!';
    }
  } catch (e) {
    console.error(e);
    return;
  }

  return minutes * 60 * 1000;
}

/**
 * Converts hours to milliseconds
 *
 * @method getMsFromHours
 * @param hours {Number}
 * @returns Number | Undefined
 * @private
 */

export function getMsFromHours(hours) {

  // hours must be a number
  try {
    if (typeof hours !== 'number') {
      throw 'getMsFromHours: "hours" param must be a number!';
    }
  } catch (e) {
    console.error(e);
    return;
  }

  return hours * 60 * 60 * 1000;
}

/**
 * Converts days to milliseconds
 *
 * @method getMsFromDays
 * @param days {Number}
 * @returns Number | Undefined
 * @private
 */

export function getMsFromDays(days) {
  // days must be a number
  try {
    if (typeof days !== 'number') {
      throw 'getMsFromDays: "days" param must be a number!';
    }
  } catch (e) {
    console.error(e);
    return;
  }

  return days * 24 * 60 * 60 * 1000;
}
